import './Style.scss';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import { Col, Row } from 'react-bootstrap';
import routes from '../contentFiles/Routes.json';

const Footer = () => {
    return (<>
        <Container className="footerContainer">
            <Row>
                <Col>
                    <b>Home</b>
                </Col>
                <Col>
                <b>Who We Are</b>
                </Col>
                <Col>
                    <b>Our Work</b>
                </Col>
                <Col>
                    <b>Contact Us</b>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Nav className="flex-column">
                        <Nav.Link href={routes.home}>Home</Nav.Link>
                    </Nav>
                </Col>
                <Col>
                    <Nav className="flex-column">
                    <Nav.Link href={routes.aboutUs}>About Us</Nav.Link>
                    <Nav.Link href={routes.vissionMission}>Our Vission & Mission</Nav.Link>
                    <Nav.Link href={routes.ourJourney}>Our journey</Nav.Link>
                    <Nav.Link href={routes.ourTeam}>Our Team</Nav.Link>
                    </Nav>
                </Col>
                <Col>
                    <Nav className="flex-column">
                        <Nav.Link href={routes.education}>Education</Nav.Link>
                        <Nav.Link href={routes.health}>Health</Nav.Link>
                        <Nav.Link href={routes.environment}>Environment</Nav.Link>
                        <Nav.Link href={routes.careAndProtection}>Care & Protection</Nav.Link> 
                    </Nav>
                </Col>
                <Col>
                    <Nav className="flex-column">
                        <Nav.Link href={routes.contact}>Contact</Nav.Link> 
                    </Nav>
                </Col>
            </Row>
            <Row style={{textAlign:"center"}}>
                <Col>
                <br></br>
                <hr></hr>
                    Copyrights (c)
                </Col>
            </Row>
      </Container>
    </>);
}
export default Footer;